import { createAction } from "typesafe-actions";

import PlaybackState from "./types/PlaybackState";

// Sets the playback state; resets dispatch IDLE_PLAYBACK_STATE.
export const setPlayback = createAction("map/userLocations/setPlayback")<PlaybackState>();
